import { format } from 'date-fns'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useOrganizationsAPI } from 'src/API/central.organizationAPI'
import { useUsersCapacityAPI } from 'src/API/central.usersAPI'
import { InputStandard } from 'src/components/standard.input'
import { MultiselectStandard } from 'src/components/standard.multiselect'
import { SelectStandard } from 'src/components/standard.select'
import { TablePlater } from 'src/components/standard.table'
import { TypographyLead, TypographyStandardP1, TypographyStandardTitleH2 } from 'src/components/typography'
import { stringToColor } from 'src/lib/utils'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'src/shadcn/ui/accordion'
import { ProjectComponent } from './component.projectCard'
// import { ImportExcelModal } from './component.importExcelModal'






export function CapacityPage() {


    const { listOrganizations } = useOrganizationsAPI()
    const [datefilter,setDatefilter] = useState<{
        fromDate?:string,
        toDate?:string
    }>({
        fromDate:format(new Date().setDate(new Date().getDate() - 28),'yyyy-MM-dd'),
        toDate:undefined
    })

    const navigate = useNavigate()


    const organizations = listOrganizations()
    const [filters, setFilters] = useState<{
        organizationIds?: string[],
        workItems?: 'completed' | 'inProgress' | 'all',
        sortBy?: 'uncompletedFirst' | 'completedFirst' | 'sortByName'
    }>({
        organizationIds: organizations.map(organization => organization.accountId),
        workItems: 'all',
        sortBy: 'completedFirst'
    })

    const {
        listUsersWithCapacity,
        isFetching,
        isLoading
    } = useUsersCapacityAPI(
        {
            filters: {
                workItems: filters.workItems === 'all' ? undefined : filters.workItems,
                organizationIds: filters.organizationIds,

            },
            sortBy: filters.sortBy,
            fromDate:datefilter.fromDate,
            toDate:datefilter.toDate
        }
    )




    return (
        <div className=' grow  flex flex-col overflow-auto'>

            <TablePlater className=' flex flex-col gap-2'>
                {/* Buttons section */}
                <div className=' flex justify-start w-full gap-4 max-w-[300px] '>
                    <MultiselectStandard
                        title='Organization'
                        name='organization'

                        onValueChange={(e) => {
                            setFilters({
                                ...filters,
                                organizationIds: e.target.value
                            })
                        }}
                        options={[
                            ...organizations.map(organization => ({
                                label: organization.accountName,
                                value: organization.accountId
                            }))
                        ]}
                        placeholder=''
                        value={filters.organizationIds}
                        maxHeight={100}
                    />
                    <SelectStandard
                        title='Status'
                        name='status'
                        onChange={(e) => {
                            setFilters({
                                ...filters,
                                workItems: e.target.value as 'completed' | 'inProgress'
                            })
                        }}
                        options={[
                            {
                                label: 'All',
                                value: 'all',
                            },
                            {
                                value: 'inProgress',
                                label: 'In Progress'
                            },
                            {
                                value: 'completed',
                                label: 'Completed'
                            },

                        ]}
                        value={filters.workItems}
                    />
                    <SelectStandard
                        title='Sort By'
                        name='status'
                        onChange={(e) => {
                            setFilters({
                                ...filters,
                                sortBy: e.target.value as any
                            })
                        }}
                        options={[

                            {
                                value: 'completedFirst',
                                label: 'completed first'
                            },
                            {
                                value: 'uncompletedFirst',
                                label: 'uncompleted first'
                            },
                            {
                                value: 'sortByName',
                                label: 'sort by name'
                            }
                        ]}
                        value={filters.sortBy}
                    />
                    <InputStandard 
                        title='from date'
                        value={datefilter.fromDate} onChange={(e) => setDatefilter({...datefilter,fromDate:e.target.value})} type='date' />
                    <InputStandard 
                        title='to date'
                        value={datefilter.toDate} onChange={(e) => setDatefilter({...datefilter,toDate:e.target.value})} type='date' />
                </div>
                {
                    isLoading && (

                        Array.from({ length: 5 }).map((_, i) => (
                            <div key={i} className=' flex items-center justify-center h-20 w-full bg-white shadow-md border animate-pulse '>
                            </div>
                        ))

                    )
                }
                {listUsersWithCapacity?.map(user => {
                    return (
                        (
                            <Accordion onDoubleClick={() => { navigate(`/home/master/capacity-single-user/${user.user.originId}`) }} key={user.user.originId} type="single" collapsible className="w-full relative">
                                <AccordionItem value={'item-1'} >
                                    <AccordionTrigger  >
                                        {user.totalPendingCapacityToday > 0 && <div className={` 
                                                    w-28 h-6 text-white absolute right-0 top-0 
                                                    flex items-center justify-center text-xs
                                                    rounded-tr-lg rounded-bl-md
                                                    bg-red-500 z-10
                                                    `}>work pending</div>}
                                        <div className='grid grid-cols-1  w-full md:grid-cols-5 gap-2 gap-y-4  bg-white'>
                                            {/* project status */}
                                            <div className='w-full flex items-center gap-2 md:col-span-3  '>
                                                <div
                                                    style={{
                                                        background: stringToColor(user.user.mailAddress)
                                                    }}
                                                    className="avatar min-h-12 min-w-12 max-h-12 max-w-12 flex items-center justify-center border rounded-full text-white ">
                                                    {user.user.displayName.charAt(0).toUpperCase()}
                                                </div>
                                                <div className=' flex flex-col text-start justify-center '>
                                                    <TypographyLead>{user.user.displayName}</TypographyLead>
                                                    <TypographyStandardP1 >{user.user.mailAddress}</TypographyStandardP1>
                                                </div>
                                            </div>
                                            <div className=' flex col-span-1 md:col-span-2'>
                                                <div className=' flex flex-col w-full place-items-end'>
                                                    <div className='flex'>
                                                        <TypographyStandardTitleH2>Projects: </TypographyStandardTitleH2>
                                                        <TypographyStandardP1>{user.projects.length}</TypographyStandardP1>
                                                    </div>
                                                    <div className='flex'>
                                                        <TypographyStandardTitleH2>Total Work Item: </TypographyStandardTitleH2>
                                                        <TypographyStandardP1>{user.totalWorkItem}</TypographyStandardP1>
                                                    </div>
                                                    <div className='flex'>
                                                        <TypographyStandardTitleH2>Completed Work Item: </TypographyStandardTitleH2>
                                                        <TypographyStandardP1>{user.completedWorkItem}</TypographyStandardP1>
                                                    </div>
                                                    <div className='flex'>
                                                        <TypographyStandardTitleH2>Capacity today: </TypographyStandardTitleH2>
                                                        <TypographyStandardP1>{user.totalCapacityToday}</TypographyStandardP1>
                                                    </div>
                                                    <div className='flex'>
                                                        <TypographyStandardTitleH2>Pending Capacity today: </TypographyStandardTitleH2>
                                                        <TypographyStandardP1>{user.totalPendingCapacityToday}</TypographyStandardP1>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </AccordionTrigger>
                                    <AccordionContent>
                                        <div className=' flex flex-col gap-1 max-h-[90vh] overflow-auto'>
                                            {user.activeProjects.map(
                                                project => {

                                                    return (
                                                        <ProjectComponent
                                                            TotalWorkItem={project.userTotalWorkItems}
                                                            completedWorkItem={project.userCompletedWorkItems}
                                                            key={project.id}
                                                            projectName={project.name}
                                                            totalTeam={project.teams}
                                                            totalTodayCapacity={project.totalTodayCapacity}
                                                            totalPendingCapacityToday={project.totalPendingCapacityToday}
                                                        />
                                                    )
                                                }
                                            )}
                                        </div>
                                    </AccordionContent>
                                </AccordionItem>
                            </Accordion>
                        )
                    )
                })
                }


            </TablePlater>
        </div>
    )

}



